import { styled } from "@mui/material";

export const ColorBox = styled("div")({
  width: "42px",
  height: "42px",
  display: "inline-block",
  marginRight: 8,
  borderRadius: "8px",
});
